interface SectionHeaderProps {
  index: string;
  kicker: string;
  title: string;
  desc?: string;
  href?: string;
  linkLabel?: string;
}

export default function SectionHeader({
  index,
  kicker,
  title,
  desc,
  href = "#grid",
  linkLabel = "查看全部",
}: SectionHeaderProps) {
  return (
    <div className="mb-8 md:mb-10 flex items-end justify-between gap-6 border-b border-background-200 pb-5">
      <div>
        <div className="mb-2 flex items-center gap-3">
          <span className="font-label text-xs font-bold tracking-[0.18em] text-primary-600">
            {kicker}
          </span>
          <span className="h-px w-8 bg-primary-300" />
          <span className="font-label text-[11px] font-medium text-foreground-400">
            PART {index}
          </span>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
            {desc}
          </p>
        )}
      </div>
      {linkLabel && (
        <a
          href={href}
          className="hidden md:inline-flex shrink-0 items-center gap-1 rounded-md px-4 py-2 text-sm font-semibold text-primary-700 whitespace-nowrap transition-colors hover:bg-primary-100 cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-line text-base" />
        </a>
      )}
    </div>
  );
}